// @flow

import React from "react";
import { connect } from "react-redux";

import { useI18n, withI18n } from "@quantum/i18n";

import { compose } from "ramda";

import SelecaoCheckboxBase from "../../../comum/SelecaoCheckboxBase";

import {
  type ActionCreator,
  getTiposAjustePreco,
  selecionarAjustesPreco,
  getAjustesPrecoSelecionados,
} from "../../../../state";
import { type Id, type TipoAjustePreco } from "../../../../model";

type Props = {
  listaAjustesPreco: Array<TipoAjustePreco>,
  ajustesPrecoSelecionados: Array<Id>,
  selecionarAjustesPreco: ActionCreator,
};

const SelecaoAjusteDePreco = ({
  listaAjustesPreco,
  ajustesPrecoSelecionados,
  selecionarAjustesPreco,
}: Props) => {
  const { translate } = useI18n();

  const onChangeAjustesPreco = ids => selecionarAjustesPreco(ids);

  return (
    <div className="ConfiguracaoMedida">
      <SelecaoCheckboxBase
        nomeSelecao={translate("configuracaoRelatorio.tipoDeAjuste")}
        itens={listaAjustesPreco}
        itensSelecionados={ajustesPrecoSelecionados}
        onChange={onChangeAjustesPreco}
        campoId="id"
        campoDescricao="traducao"
      />
    </div>
  );
};

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaAjustesPreco: getTiposAjustePreco(state).map(ajuste => ({
        ...ajuste,
        traducao: ownProps.translate(ajuste.chaveTraducao),
      })),
      ajustesPrecoSelecionados: getAjustesPrecoSelecionados(state),
    }),
    {
      selecionarAjustesPreco,
    }
  )
)(SelecaoAjusteDePreco);
